export default __webpack_public_path__ + "b52de447c7ceaa2b262ce368feebe317.pdf";